import { useNavigate } from 'react-router-dom'
import { Logo } from '../assets/logo'

export const Footer = () => {
  const navigate = useNavigate()

  return (
    <footer>
      <div>
        <Logo handler={() => navigate('/', { viewTransition: true })} />
        <div className='footer_supporting'>
          <span
            className='span-a'
            onClick={() => navigate('/experience?ctx=global', { viewTransition: true })}>
            Support & Feedback
          </span>
          <hr />
          <span onClick={() => navigate('/terms', { viewTransition: true })}>
            Terms & Conditions
          </span>
          <hr />
          <span onClick={() => navigate('/privacy', { viewTransition: true })}>Privacy Policy</span>
        </div>
      </div>
    </footer>
  )
}
